// extracted by mini-css-extract-plugin
export default {"inputDepartamento":"stylesDepartamentos_inputDepartamento__9aB6z"};